<template>
    <el-dialog title="选择档位" :visible.sync="innerVisible" class="dialog-table" width="800px" :before-close="closeDialogTable">
        <div class="tableTh">
            <el-table :data="tableData.result" border ref="multipleTable" @selection-change="handleSelectionChange" @row-click="handleRowClick" max-height="345" row-key="id" style="width: 100%" class="tableStyle">
                <el-table-column type="selection" width="60" align="center">
                </el-table-column>
                <el-table-column label="充值类型" width="120">
                    <template slot-scope="scope">
                        <span v-if="scope.row.rechargeType == 0">看点</span>
                        <span v-if="scope.row.rechargeType == 1">普通会员</span>
                        <span v-if="scope.row.rechargeType == 2">连续续费会员</span>
                    </template>
                </el-table-column>
                <el-table-column prop="rechargeInfo" label="充值说明" width="120"></el-table-column>
                <el-table-column label="充值金额">
                    <template slot-scope="scope">
                        <div class="td-info" style="padding: 5px 0;">
                            <p>首月：{{scope.row.money}}</p>
                            <p>次月：{{scope.row.nextMonthPric}}</p>
                            <p>划线价：{{scope.row.originalPrice}}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="templateInfo" label="档位描述"></el-table-column>
                <el-table-column prop="subscript" label="角标文案"></el-table-column>
                <!--<el-table-column label="默认选中">-->
                    <!--<template slot-scope="scope">-->
                        <!--<span v-if="scope.row.selected == 0">否</span>-->
                        <!--<span v-if="scope.row.selected == 1">是</span>-->
                    <!--</template>-->
                <!--</el-table-column>-->
            </el-table>
            <div class="foot-table" style="text-align:center;">
                <el-pagination
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :page-sizes="[5, 20, 50, 100, 200, 500]"
                    :page-size="pageSize"
                    background
                    :current-page="currentPage"
                    layout="sizes, prev, pager, next, jumper, ->, total"
                    :total="tableData.totalNum">
                </el-pagination>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button @click="closeDialogTable">取 消</el-button>
            <el-button type="primary" @click="tableSureBtn">确 定</el-button>
        </div>
    </el-dialog>
</template>
<script>
// import { listRechargeMedia } from "@/api/dysvzk/dymedia/add";
import { list } from "@/api/wb/app/recharge";
// import { listRechargeMore } from "@/api/dysvzk/app/group";
var selectList = []
var selectListStr = ''
export default {
    name: 'RechargeTableMore',
    props: {
        visible: {
            type: Boolean,
            required: true
        },
        // selectRecharge: {
        //     type: Object,
        //     required: true
        // },
        selectListType: String,
        appId: String,
        selectList:{
            type: Array,
            required: true
        },
    },
    data() {
        return {
            innerVisible: this.visible,
            selected: [],
            formInline: {
                svId: '',
                svName: ''
            },
            tableData: {
                pageSize: 20,
                pageNo: 1,
                totalPage: 1,
                totalNum: 0,
                result: []
            },
            currentPage: 1,
            pageSize: 5,
            currentRow: ''
        }
    },
    watch: {
        visible(newValue) {
            this.innerVisible = newValue;
            // 弹框显示赋值默认值
            this.$nextTick(()=>{
                this.$refs.multipleTable.clearSelection();
                console.log("this.selectList",this.selectList)
                // if (this.selectList.length > 0) {
                //     this.$refs.multipleTable.toggleRowSelection(this.selectList[0],true);
                //     this.selectList.forEach(row => {
                //         this.$refs.multipleTable.toggleRowSelection(row,true);
                //         selectList.push(row.id)
                //         console.log('设置',row)
                //     });
                // }
            })
        },
        appId(newValue) {
            this.appId = newValue
            this.getTableRechargeMore()
        },
        innerVisible(newValue) {
            this.$emit('update:visible', newValue);
        },
        // selectList(newValue){
        //     console.log("selectList",newValue)
        // }
    },
    mounted() {
        this.getTableRechargeMore()
    },
    methods: {
        search () {
            this.currentPage = 1
            this.getTableRechargeMore()
        },
        resetQuery() {
            this.$refs['formInline'].resetFields()
            this.getTableRechargeMore()
        },
        handleRowClick(row) {
            this.$refs.multipleTable.toggleRowSelection(row);
        },
        // 多选
        handleSelectionChange(val) {
            console.log(val)
            selectList = []
            val.forEach((item) => {
                selectList.push(item.id)
            })
            selectListStr = selectList.toString()
            this.currentRow = val
        },
        // 分页
        handleCurrentChange (value) {
            this.currentPage = value
            this.getTableRechargeMore()
        },
        // pageSize切换
        handleSizeChange (val) {
            this.pageSize = val
            this.currentPage = 1
            this.getTableRechargeMore()
        },
        // 确定按钮
        tableSureBtn() {
            if(selectListStr){
                this.$emit('gearSure', {
                    currentRow: this.currentRow,
                    selectListStr: selectListStr,
                });
                this.$emit('cancelDialogRecharge', false);
            } else {
                this.$message.error('请选择档位')
            }
            
            // this.$emit('RechargeSure', this.currentRow);
            // this.$emit('cancelDialogRecharge', false);
            // this.$refs.singleTable.setCurrentRow();
        },
        // 关闭弹框
        closeDialogTable () {
            console.log(22)
            this.$emit('cancelDialogRecharge', false);
        },
        getTableRechargeMore() {
            let json2 = {
                appId: this.appId,
                pageNo: this.currentPage,
                pageSize: this.pageSize
            };
            let json1 = this.formInline;
            let paramJson = { ...json1, ...json2 };
            list(paramJson).then(response => {
                if (response.data.head.flag === 0) {
                    this.tableData = response.data.content
                } else {
                    this.$message.error(response.data.head.desc)
                }
            });
        },
    }
}
</script>
